<template>
  <va-navbar class="app-navbar">
    <header-selector slot="selector" :minimized.sync="minimizedProxy"/>
    <div class="app-navbar__actions row flex-nowrap align--center">
      <profile-dropdown class="va-navbar__item">
        <div class="user-card">
          <div class="user-avatar">
            {{ iniciales }}
          </div>
          <div class="user-info">
            <div class="user-name"
                v-if="this.$session.get('IberoJWTAdmin')">
              {{ this.$session.get('IberoJWTAdmin').given_name }}
              {{ this.$session.get('IberoJWTAdmin').family_name }}
            </div>
            <div class="user-email"
                v-if="$session.get('IberoJWTAdmin')">
              {{ this.$session.get('IberoJWTAdmin').unique_name }}
            </div>
          </div>
        </div>
      </profile-dropdown>

    </div>
  </va-navbar>
</template>

<script>
import VaIconVuestic
  from 'vuestic-ui/src/components/vuestic-components/va-icon/va-iconset/VaIconVuestic'
import HeaderSelector from './components/HeaderSelector'
import LanguageDropdown from './components/dropdowns/LanguageDropdown'
import ProfileDropdown from './components/dropdowns/ProfileDropdown'
import NotificationDropdown from './components/dropdowns/NotificationDropdown'
import MessageDropdown from './components/dropdowns/MessageDropdown'
import SettingsDropdown from './components/dropdowns/SettingsDropdown'
import ColorDropdown from './components/dropdowns/ColorDropdown'

export default {
  name: 'app-navbar',
  components: {
    SettingsDropdown,
    ColorDropdown,
    VaIconVuestic,
    HeaderSelector,
    MessageDropdown,
    NotificationDropdown,
    LanguageDropdown,
    ProfileDropdown,
  },
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      userName: 'Vasili S',
    }
  },
  computed: {
    minimizedProxy: {
      get () {
        return this.minimized
      },
      set (minimized) {
        this.$emit('update:minimized', minimized)
      },
    },
  },
  created: function () {
    if (!this.$session.get('IberoJWTAdminLogin')) {
      this.$router.push({ name: 'login' })
    }
  },
  computed: {
    iniciales () {
      const user = this.$session.get('IberoJWTAdmin')
      if (!user) return ''

      const nombre = user.given_name || ''
      const apellido = user.family_name || ''

      return `${nombre.charAt(0)}${apellido.charAt(0)}`.toUpperCase()
    },
    minimizedProxy: {
      get () {
        return this.minimized
      },
      set (minimized) {
        this.$emit('update:minimized', minimized)
      },
    },
  }
}
</script>
<style lang="scss">
.header-selector
{
  align-items: center;
}

/* */
.user-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: all .2s ease;
}

.user-card:hover {
  background: rgba(0,0,0,0.05);
}

/* Avatar */

.user-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #2c3e50;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

/* Info */

.user-info {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.user-title {
  font-size: 11px;
  color: #9aa0a6;
  font-weight: 600;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
}

.user-email {
  font-size: 12px;
  color: #6c757d;
}

.user-extra {
  font-size: 11px;
  color: #a0a0a0;
}
/* */

.app-navbar {
  &__button {
    width: 10.8125rem;
    .va-button__content__icon-left.fa-github {
      font-size: 1.5rem;
    }
  }
  &__actions {
    justify-content: flex-end;
  }
  &__mailto-link:hover {
    filter: brightness(85%);
  }
  @include media-breakpoint-down(lg) {
    &__button {
      display: none !important;
    }
    .profile-dropdown {
      margin: auto 0 auto .75rem;
    }
  }
  @include media-breakpoint-down(md) {
    @at-root .va-navbar__text {
      display: none !important;
    }
  }
  @include media-breakpoint-down(sm) {
    &__button {
      display: none !important;
    }
    &__actions {
      justify-content: space-around;
      padding: 0 .5rem;
    }
    .profile-dropdown {

      .va-dropdown-popper {
        right: 0 !important;
        left: auto !important;
      }

      &__content {
        background-color: $dropdown-background;
        box-shadow: $gray-box-shadow;
        border-radius: .5rem;

        width: 260px;       /* ← ancho del menú */
        min-width: 220px;
        padding: 8px 0;
      }

      &__item {
        display: block;
        width: 100%;        /* ← ocupa todo el ancho */
        padding: 10px 16px;
        text-align: left;
        color: $vue-darkest-blue;

        &:hover {
          background: rgba(0,0,0,0.05);
          color: $vue-green;
        }
      }
    }
  }
}
.menu-toggle-btn {
  margin-right: 12px;
  border-radius: 10px;
  transition: all .2s ease;
}

.menu-toggle-btn:hover {
  background: rgba(0,0,0,0.05);
  transform: scale(1.05);
}
</style>
